// extracted by mini-css-extract-plugin
module.exports = {"container":"DropdownMenu_container__23U9j","title":"DropdownMenu_title__27m4n","items":"DropdownMenu_items__1UERZ","expanded":"DropdownMenu_expanded__lN74v"};